import { Box } from '@mui/material';
import React from 'react';
import { Title } from 'react-admin';
import { Navigate, useNavigate } from 'react-router-dom';

import useCanWrite from '../../../hooks/useCanWrite';
import { BackToLaunches } from './BackToLaunches';
import { NewClientFlow } from './LaunchFlow';
import { useLaunchPaths } from './paths';

const NewClientPage: React.FC = () => {
  const navigate = useNavigate();
  const paths = useLaunchPaths();
  const canWrite = useCanWrite();
  // Read-only admins can view launches but not create clients.
  if (!canWrite) {
    return <Navigate to={paths.list} replace />;
  }
  return (
    <Box marginTop={2}>
      <Title title="Launch Manager" />
      <BackToLaunches />
      {/* Replaced so going back doesn't reopen an empty new client form. */}
      <NewClientFlow
        onStarted={(id) => navigate(paths.launch(id), { replace: true })}
      />
    </Box>
  );
};

export default NewClientPage;
